<div class="wrap">
  <div class="header">
    <div class="title">
      <mat-label [routerLink]="['/admin']" routerLinkActive="router-link-active">
        <fa-icon [icon]="faChevronLeft"></fa-icon>
        <h2>Liste des votes </h2>
      </mat-label>
    </div>
    <div class="search_bar">
      <form [formGroup]="searchForm">
        <input type="text" placeholder="Chercher un vote ..." (input)="applyFilter($event.target)"
          formControlName="keyword">
      </form>
      <fa-icon [icon]="faTimes" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
      <fa-icon [icon]="faSearch" *ngIf="!valueInput"></fa-icon>
    </div>
  </div>
  <div class="content">
    <div class="table_mobile">
      <table mat-table matSort multiTemplateDataRows [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="title"> Titre
          </th>
          <td mat-cell *matCellDef="let element"> {{element?.title}} </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsMobile.length">
            <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <div class="rating_details" *ngIf="!element.subMovies">
                <div class="img">
                </div>
                <div class="description">
                  <div class="rating">
                     <p>Appréciation</p>
                       <ng-rating-bar [matTooltip]="element?.ratingsAverage?.toFixed(2) + '/5'" [value]="element?.ratingsAverage" [disabled]="true" [ratingCount]="5"></ng-rating-bar>
                       <span>{{element?.ratingsAverage?.toFixed(2) + '/5'}}</span> 
                  </div>
                   <span>{{element.ratingsNumber}} {{element.ratingsNumber >= 2 ? 'votes' : 'vote' }}</span>
                   <div class="rating">
                    <p>Côté dérangeant</p>
                    <ng-rating-bar [matTooltip]="element?.ratingsAverage?.toFixed(2) + '/5'" [value]="element?.ratingsAverage" [disabled]="true" [ratingCount]="5"></ng-rating-bar>
                    <span>{{element?.ratingsAverage?.toFixed(2) + '/5'}}</span> 
               </div>
                <span>{{element.ratingsNumber}} {{element.ratingsNumber >= 2 ? 'votes' : 'vote' }}</span>
                </div>
              </div>
<!-- subMovie -->
              <div *ngIf="element.subMovies">
              <div class="rating_details" *ngFor="let subMov of element.subMovies;">
                <h6>{{subMov.title}}</h6>
                <!-- <div class="img">
                  <img [src]="subMov.image" [alt]="subMov.title">
                </div> -->
                <div class="description">
                  <div class="rating">
                     <p>Appréciation</p>
                       <ng-rating-bar [matTooltip]="subMov?.ratingsAverage?.toFixed(2) + '/5'" [value]="subMov?.ratingsAverage" [disabled]="true" [ratingCount]="5"></ng-rating-bar>
                       <span>{{subMov?.ratingsAverage?.toFixed(2) + '/5'}}</span> 
                  </div>
                   <span>{{subMov.ratingsNumber}} {{subMov.ratingsNumber >= 2 ? 'votes' : 'vote' }}</span>
                   <div class="rating">
                    <p>Côté dérangeant</p>
                    <ng-rating-bar [matTooltip]="subMov?.ratingsAverage?.toFixed(2) + '/5'" [value]="subMov?.ratingsAverage" [disabled]="true" [ratingCount]="5"></ng-rating-bar>
                    <span>{{subMov?.ratingsAverage?.toFixed(2) + '/5'}}</span> 
               </div>
                <span>{{subMov.ratingsNumber}} {{subMov.ratingsNumber >= 2 ? 'votes' : 'vote' }}</span>
                </div>
              </div>
            </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsMobile" ></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumnsMobile;" class="example-element-row"
          [class.example-expanded-row]="expandedElement === element"
          (click)="updateExpandedElement(element)" >
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" ></tr>
      </table>
    </div>
    <div class="table_desktop">
      <table mat-table matSort multiTemplateDataRows [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="image">
          <th mat-header-cell *matHeaderCellDef  mat-sort-header="image" class="cell_medium"> Aperçu</th>
          <td mat-cell *matCellDef="let element" class="cell_medium">
            <div class="img"><img [src]="element.image" alt=""></div>
          </td>
        </ng-container>
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="title"> Titre
          </th>
          <td mat-cell *matCellDef="let element"> {{element?.title}} </td>
        </ng-container>
        <ng-container matColumnDef="nbrOfRating">
          <th mat-header-cell *matHeaderCellDef class="cell_action"> Nombre de votes </th>
          <td mat-cell *matCellDef="let element" class="cell_action"> {{element?.ratingsNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="rating">
          <th mat-header-cell *matHeaderCellDef  class="cell_action"> Appréciation </th>
          <td mat-cell *matCellDef="let element" class="cell_action">
            <ng-rating-bar *ngIf="!element.subMovies" [matTooltip]="element?.ratingsAverage?.toFixed(2) + '/5'" [value]="element?.ratingsAverage" [disabled]="true" [ratingCount]="5"></ng-rating-bar>
          </td>
        </ng-container>
        <ng-container matColumnDef="disturbing">
          <th mat-header-cell *matHeaderCellDef  class="cell_action"> Coté dérangeant </th>
          <td mat-cell *matCellDef="let element" class="cell_action">
            <ng-rating-bar *ngIf="!element.subMovies" [matTooltip]="element?.disturbingAverage?.toFixed(2) + '/5'" [value]="element?.disturbingAverage" [disabled]="true" [ratingCount]="5"></ng-rating-bar>
          </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsDesktop.length">
            <div *ngIf="element.subMovies" class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <app-table-submovie [subMovies]="element.subMovies"></app-table-submovie>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsDesktop" ></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumnsDesktop;" class="example-element-row"
          [class.example-expanded-row]="expandedElement === element"
          [class.has-sub-movies]="element.subMovies"
          (click)="updateExpandedElement(element)" >
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" ></tr>
        <!-- <tr mat-header-row *matHeaderRowDef="displayedColumnsDesktop"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsDesktop;"> </tr> -->
      </table>
    </div>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event" [color]="color">
    </mat-paginator>
  </div>
</div>
